// Fields typed into a box: text, textarea, number, price, mobile, email, national_code, postal_code.
import { h } from "../h.js";
import { slot_props } from "../styles.js";
import { LIMITS } from "../form_helper.js";
import { TEXT_FIELD_KINDS } from "../constants.js";
import { format_price, parse_price_input, clean_number_input } from "../format.js";
import { FieldShell, control_aria } from "./shell.js";

const kind_of = (type) => TEXT_FIELD_KINDS[type] || TEXT_FIELD_KINDS.text;

// what the box shows for the value the form keeps
export const display_value = (type, value) => {
    if (value === undefined || value === null) {
        return "";
    }
    return type === "price" ? format_price(value) : String(value);
};

// what the form keeps for what was typed; "" is "nothing" (the key is removed)
export const value_from_input = (type, text) => {
    const next = type === "price" ? parse_price_input(text) : (type === "number" ? clean_number_input(text) : text);
    return next === "" ? undefined : next;
};

export const TextualField = ({ field, id, value, on_change, error, required, disabled, styles, class_names, price_unit }) => {
    const type = field.type;
    const kind = kind_of(type);
    const common = {
        ...control_aria({ id, field, error, required, disabled }),
        ...slot_props({ slot: "input", class_names, styles, type }),
        placeholder: field.placeholder || undefined,
        value: display_value(type, value),
        onChange: (event) => on_change(value_from_input(type, event.target.value)),
    };
    const control = type === "textarea"
        ? h("textarea", { ...common, rows: Number.isInteger(field.data?.rows) ? field.data.rows : 4, maxLength: LIMITS.TEXTAREA_MAX, dir: field.direction || undefined })
        : h("input", {
            ...common,
            type: kind.input_type,
            inputMode: kind.input_mode,
            // the admin's direction wins over the type's own (a mobile or an email is left-to-right)
            dir: field.direction || kind.dir,
            autoComplete: kind.autocomplete,
            maxLength: type === "text" ? LIMITS.TEXT_MAX : undefined,
        });
    // a price may say its unit after the number (`price_unit` of the hook): the box is then the wrapper around the input and the unit
    const unit = type === "price" && typeof price_unit === "string" && price_unit !== "" ? price_unit : null;
    const shown = unit
        ? h("div", slot_props({ slot: "control", class_names, styles, type }), control, h("span", slot_props({ slot: "adornment", class_names, styles, type }), unit))
        : control;
    return h(FieldShell, { field, id, error, required, disabled, styles, class_names }, shown);
};
